import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Select,
  Option,
} from "@material-tailwind/react";
import React, { useState } from "react";
import {
  isValidEmail,
  isValidName,
  isValidPhoneNumber,
  isValidPassword,
} from "../../utils/helpers";
import { AlertCustomStyles } from "../layout/AlertCustomStyles";
import { formatPhone, getDays, getYears } from "../../utils/helpers";
import { getMonths } from "../../utils/constants";
import UserService from "../../services/user.service";
const RegisterStepOne = ({ onStepOneComplete, firstStepData }) => {
  const [values, setValues] = useState({
    firstName: firstStepData.firstName || "",
    lastName: firstStepData.lastName || "",
    email: firstStepData.email || "",
    phoneNumber: firstStepData.phoneNumber || "",
    password: firstStepData.password || "",
    day: firstStepData.day || "",
    month: firstStepData.month || "",
    year: firstStepData.year || "",
  });
  const [alert, setAlert] = useState("");
  const [msg, setMsg] = useState("");
  const [size, setSize] = useState(null);
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [termsNotChecked, setTermsNotChecked] = useState(true);
  let [errors, setErrors] = useState({
    firstName: 0,
    lastName: 0,
    email: 0,
    phoneNumber: 0,
    password: 0,
    day: 0,
    month: 0,
    year: 0,
  });
  const inputs = [
    {
      id: 0,
      name: "email",
      type: "email",
      placeholder: "Email",
      errorMessage: "Email address is invalid!",
      label: "Email",
      required: true,
    },

    {
      id: 1,
      name: "firstName",
      type: "text",
      placeholder: "firstName",
      errorMessage: "First Name is required!",
      label: "First Name",
      required: true,
    },
    {
      id: 2,
      name: "lastName",
      type: "text",
      placeholder: "lastName",
      errorMessage: "Last Name is required!",
      label: "Last Name",
      required: true,
    },

    {
      id: 3,
      name: "phoneNumber",
      type: "number",
      placeholder: "Phone Number",
      errorMessage: "Phone number is invalid!",
      label: "Phone Number",
      required: true,
    },

    {
      id: 4,
      name: "password",
      type: "password",
      placeholder: "Password",
      errorMessage: "Password should be 8-20 characters!",
      label: "Password",
      pattern: `^[a-zA-Z0-9!@#$%^&*]{8,20}$`,
      required: true,
    },
  ];
  const handleSubmit = async (e) => {
    if (
      Object.values(errors).every((v) => v === 0) &&
      !Object.values(values).some((x) => x == "") &&
      termsAndConditions
    ) {
      const exist = await UserService.userExist({ email: values["email"] });
      if (!exist.exist) {
        onStepOneComplete(values);
      } else {
        setMsg("Email already registered. Go to login");
        setAlert("fail");
      }
    } else {
      if (!termsAndConditions) setTermsNotChecked(false);
      if (!values["day"]) errors["day"] = 1;
      if (!values["month"]) errors["month"] = 1;
      if (!values["year"]) errors["year"] = 1;
      setMsg("Invalid Information");
      setAlert("fail");
    }
  };
  const handleOpen = (value) => setSize(value);

  const onChange = (e) => {
    setValues({
      ...values,
      [e.target.name]:
        e.target.name == "phoneNumber"
          ? e.target.value.replace(/\D/g, "")
          : e.target.value,
    });
  };
  const handleValidation = (e) => {
    if (e.target.name == "firstName")
      !isValidName(e.target.value)
        ? setErrors({ ...errors, [e.target.name]: 1 })
        : setErrors({ ...errors, [e.target.name]: 0 });
    if (e.target.name == "lastName")
      !isValidName(e.target.value)
        ? setErrors({ ...errors, [e.target.name]: 1 })
        : setErrors({ ...errors, [e.target.name]: 0 });
    if (e.target.name == "email") {
      !isValidEmail(e.target.value)
        ? setErrors({ ...errors, [e.target.name]: 1 })
        : setErrors({ ...errors, [e.target.name]: 0 });
    }
    if (e.target.name == "phoneNumber")
      !isValidPhoneNumber(e.target.value)
        ? setErrors({ ...errors, [e.target.name]: 1 })
        : setErrors({ ...errors, [e.target.name]: 0 });
    if (e.target.name == "password")
      !isValidPassword(e.target.value)
        ? setErrors({ ...errors, [e.target.name]: 1 })
        : setErrors({ ...errors, [e.target.name]: 0 });
  };
  const setDayChange = (e) => {
    errors["day"] = 0;
    setValues({ ...values, day: e });
  };
  const setMonthChange = (e) => {
    errors["month"] = 0;
    setValues({ ...values, month: e });
  };
  const setYearChange = (e) => {
    errors["year"] = 0;
    setValues({ ...values, year: e });
  };
  return (
    <div>
      <div className="mx-auto w-full max-w-none py-2">
        <div className="relative m-auto flex w-full flex-col text-[#302521]">
          <h1 className="text-xl font-semibold leading-snug tracking-normal text-[#302521] sm:text-[22px]">
            Create your account
          </h1>
          <p className="mt-1.5 text-[13px] leading-relaxed text-[#766b64]">
            A few details to get your transfers started.
          </p>
          <form className="mt-3 mb-1 flex w-full max-w-[300px] flex-col gap-1.5">
            {alert && (
              <div className="register-form-alert">
                <AlertCustomStyles status={alert} message={msg} />
              </div>
            )}
            {inputs.map((input) => (
              <div className="relative w-full" key={input.name}>
                <label
                  htmlFor={input.name}
                  className="mb-1 block text-[10px] font-medium text-[#514641]"
                >
                  {input.name == "password"
                    ? "Password (at least 8 characters)"
                    : input.label}
                </label>
                <input
                  id={input.name}
                  type={
                    input.name == "password"
                      ? "password"
                      : input.name == "phoneNumber"
                      ? "tel"
                      : input.name == "email"
                      ? "email"
                      : "text"
                  }
                  onChange={onChange}
                  value={
                    input.name == "phoneNumber"
                      ? formatPhone(values[input.name], "Canada")
                      : values[input.name]
                  }
                  onBlur={handleValidation}
                  name={input.name}
                  aria-invalid={!!errors[input.name]}
                  maxLength={input.name == "phoneNumber" ? 10 : undefined}
                  className={`h-[32px] w-full rounded-md border bg-[#fffdf9] px-3 text-[12px] text-[#302521] outline-none transition placeholder:text-[#918482] focus:border-[#882699] ${errors[input.name] ? "border-[#c53030]" : "border-[#d8cfc4]"}`}
                />
                {errors[input.name] == 1 && (
                  <span className="ml-1 text-[10px] text-[#c53030]">
                    {input.errorMessage}
                  </span>
                )}
              </div>
            ))}
            <div className="text-[10px] font-medium text-[#514641]">Date of birth</div>
            <div className="grid w-full grid-cols-3 gap-2">
              <Select
                label="Day"
                name="day"
                className="!flex !h-[40px] !min-h-[40px] !items-center !justify-between !gap-1 !rounded-md !border-[#d8cfc4] !px-2.5 !py-2 !text-xs !leading-none !text-[#302521]"
                labelProps={{ className: "!text-[11px] !text-[#766b64] peer-focus:!text-[#882699]" }}
                menuProps={{ className: "!z-[1000] !max-h-40 !min-w-[76px] !overflow-y-auto !rounded-lg !border !border-[#e6ddd2] !bg-[#fffdf9] !p-1 !text-[#302521] !shadow-lg" }}
                selected={(element) =>
                  element &&
                  React.cloneElement(element, {
                    disabled: true,
                    className:
                      "flex min-w-0 items-center whitespace-nowrap px-0 text-xs leading-none opacity-100 pointer-events-none",
                  })
                }
                value={values["day"]}
                onChange={setDayChange}
                containerProps={{ className: "!min-w-0 !w-full" }}
                error={errors["day"]}
              >
                {getDays().map((day) => (
                  <Option
                    key={day}
                    value={day}
                    className="flex w-full items-center !whitespace-nowrap !px-2.5 !py-1.5 !text-xs !text-[#302521] hover:!bg-[#f0e5f3]"
                  >
                    {day}
                  </Option>
                ))}
              </Select>
              <Select
                label="Month"
                name="month"
                className="!flex !h-[40px] !min-h-[40px] !items-center !justify-between !gap-1 !rounded-md !border-[#d8cfc4] !px-2.5 !py-2 !text-xs !leading-none !text-[#302521]"
                labelProps={{ className: "!text-[11px] !text-[#766b64] peer-focus:!text-[#882699]" }}
                menuProps={{ className: "!z-[1000] !max-h-40 !min-w-[108px] !overflow-y-auto !rounded-lg !border !border-[#e6ddd2] !bg-[#fffdf9] !p-1 !text-[#302521] !shadow-lg" }}
                selected={(element) =>
                  element &&
                  React.cloneElement(element, {
                    disabled: true,
                    className:
                      "flex min-w-0 items-center whitespace-nowrap px-0 text-xs leading-none opacity-100 pointer-events-none",
                  })
                }
                value={values["month"]}
                onChange={setMonthChange}
                containerProps={{
                  className: "!min-w-0 !w-full",
                }}
                error={errors["month"]}
              >
                {getMonths.map((month) => (
                  <Option
                    key={month}
                    value={month}
                    className="flex w-full items-center !whitespace-nowrap !px-2.5 !py-1.5 !text-xs !text-[#302521] hover:!bg-[#f0e5f3]"
                  >
                    {month}
                  </Option>
                ))}
              </Select>
              <Select
                label="Year"
                name="year"
                className="!flex !h-[40px] !min-h-[40px] !items-center !justify-between !gap-1 !rounded-md !border-[#d8cfc4] !px-2.5 !py-2 !text-xs !leading-none !text-[#302521]"
                labelProps={{ className: "!text-[11px] !text-[#766b64] peer-focus:!text-[#882699]" }}
                menuProps={{ className: "!z-[1000] !max-h-40 !min-w-[82px] !overflow-y-auto !rounded-lg !border !border-[#e6ddd2] !bg-[#fffdf9] !p-1 !text-[#302521] !shadow-lg" }}
                selected={(element) =>
                  element &&
                  React.cloneElement(element, {
                    disabled: true,
                    className:
                      "flex min-w-0 items-center whitespace-nowrap px-0 text-xs leading-none opacity-100 pointer-events-none",
                  })
                }
                value={values["year"]}
                onChange={setYearChange}
                containerProps={{
                  className: "!min-w-0 !w-full",
                }}
                error={errors["year"]}
              >
                {getYears().map((year) => (
                  <Option
                    key={year}
                    value={year}
                    className="flex w-full items-center !whitespace-nowrap !px-2.5 !py-1.5 !text-xs !text-[#302521] hover:!bg-[#f0e5f3]"
                  >
                    {year}
                  </Option>
                ))}
              </Select>
            </div>
            <div class="inline-flex items-center">
              <label
                class="relative -ml-2.5 flex cursor-pointer items-center rounded-full p-3"
                htmlFor="remember"
              >
                <input
                  type="checkbox"
                  onClick={() => setTermsAndConditions(!termsAndConditions)}
                  className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-[#d8cfc4] transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-[#882699] before:opacity-0 before:transition-opacity checked:border-[#882699] checked:bg-[#882699] checked:before:bg-[#882699] hover:before:opacity-10"
                  id="remember"
                />
                <span class="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-3.5 w-3.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="1"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </span>
              </label>
              <label
                className="mt-px cursor-pointer select-none font-light text-[#514641]"
                htmlFor="remember"
              >
                <p className="flex items-center text-[11px] font-normal leading-normal text-[#514641]">
                  I agree the
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    className="font-medium text-[#882699] transition-colors hover:text-[#6e1e7c]"
                  >
                    &nbsp;Terms and Conditions
                  </a>
                </p>
              </label>
            </div>
            {!termsNotChecked && (
              <div class="ml-2 text-[10px] text-[#e53935] ">
                Please agree the terms and conditions
              </div>
            )}
            <button
              onClick={handleSubmit}
              /* disabled={
                !isValidEmail(values.Email) ||
                !isValidPassword(values.Password) ||
                !isValidName(values.name) ||
                !isValidPhoneNumber(values.PhoneNumber)
              } */
              className="mt-1 block w-full select-none rounded-lg bg-[#882699] px-6 py-2 text-center text-xs font-semibold uppercase tracking-wide text-white shadow-[0_6px_18px_rgba(136,38,153,0.18)] transition hover:bg-[#9e32b4] focus:outline-none focus:ring-2 focus:ring-[#882699]/30 disabled:pointer-events-none disabled:opacity-50"
              type="button"
            >
              Continue
            </button>
          </form>
        </div>
        <Dialog open={size === "xl"} size={size || "md"} handler={handleOpen}>
          <DialogHeader>
            ADULIS MONEY SERVICES Terms and Conditions
          </DialogHeader>
          <DialogBody style={{ overflow: "auto", maxHeight: "680px" }}>
            <h1>We are working on it...</h1>
          </DialogBody>
          <DialogFooter>
            <Button
              variant="text"
              color="red"
              onClick={() => handleOpen(null)}
              className="mr-1  md:text-[15px] text-[12px]"
            >
              <span>Cancel</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </div>
    </div>
  );
};
export default RegisterStepOne;
